import React, { useEffect, useState } from "react";
import Modal from "../../../../../commons/modal/Modal";
import { ButtonVariant } from "@bale/ui";
import { strings } from "../../../../../../intl/fa";
import { useRequest } from "../../../../../../hooks/useRequest";
import { inquireDataThunk } from "../../../../../../core/inquireData/inquireData.thunk";
import { InquireDataResponse } from "../../../../../../core/inquireData/inquireData.api";
import { NpsForm } from "../NpsForm";

export const NpsModal: React.FC<
  React.PropsWithChildren<{
    adId: string;
  }>
> = ({ adId }) => {
  const { sendRequest: inquireData } = useRequest(inquireDataThunk);
  const [showNpsModal, setShowNpsModal] = useState(false);
  const [score, setScore] = useState<number | undefined>();

  const [submit, setSubmit] = useState(false);
  useEffect(() => {
    inquireData({
      ad_id: adId,
      onSuccess: (res: any) => {
        if (res.show_nps) {
          setShowNpsModal(true);
        }
      },
    });
  }, []);

  const closeModal = () => setShowNpsModal(false);

  const submitHandler = () => {
    setSubmit(true);
  };

  if (!showNpsModal) return null;

  return (
    <Modal
      title={strings.nps.title}
      onClose={closeModal}
      primaryButton={{
        label: strings.nps.submit_feedback,
        disable: score === undefined,
        onClick: submitHandler,
      }}
      secondaryButton={{
        label: strings.common.button.cancel,
        // variant: ButtonVariant.Outlined,
        // color: "#7A869A",
        onClick: closeModal,
      }}
    >
      <NpsForm
        adId={adId}
        submit={submit}
        score={score}
        onScoreChange={setScore}
        onSubmit={closeModal}
      />
    </Modal>
  );
};
